<template>

    <m-edit1/>

    <m-single-store-500 v-bind='{...{"storeLink":null},...{}}' :style='""' class="single-store-archive-500 my-5" ></m-single-store-500>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSingleStore500 from '@moeinmdn/miw-alpha-components/src/package/MultipleStore/Single/SingleStore500/SingleStore500';

export default {
    name: 'HomeView',
    components: {mEdit1, mSingleStore500 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
